import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import IndividualClient from "../components/IndividualClient";

const IndividualClientPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Individual Client' />

        {/* BlankPageLayer */}
        <IndividualClient />
      </MasterLayout>
    </>
  );
};

export default IndividualClientPage;

